import React, { useEffect } from 'react'
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { Select } from 'antd';
import moment from 'moment-timezone';
import './_SueItemUpdate.css';

interface GeneralCarDetailsProps {
    sueData: any;
    sueInternalNumber: string;
    openingDate: Date | null;
    closingDate: Date | null;
    paymentDate: Date | null;
    customerCheckMaturityDate: Date | null;
    sueTypeLabel: string;
    sueActivityStatusLabel: string;
    sueStatusLabel: string;
    sueHandlerName: string;
    insuranceCompanyLabel: string;
    formErrors: any;
    showNewPayment: any;
    newSuePayment: any;
    sueHandlingProcess: string;
    onParameterChange: (e: any, field: string, isRequired?: boolean) => void;
    onParameterPaymentChange: (e: any, field: string) => void;
    onSueSummaryAmountChange: (e: any, field: string, isRequired?: boolean) => void;
    onChangeOpeningDate: (e: any) => void;
    onChangeClosingDate: (e: any) => void;
    onChangePaymentDate: (e: any) => void;
    onChangeCustomerCheckMaturityDate: (e: any) => void;
    onDateChange: (field: string, date: Date) => void;
    onSueTypeChange: (e: any) => void;
    onSueActivityStatusChange: (e: any) => void;
    onSueStatusChange: (e: any) => void;
    onSueHandlerChange: (e: any) => void;
    onClearSueType: () => void;
    onClearSueActivityStatus: () => void;
    onClearSueStatus: () => void;
    onClearSueHandler: () => void;
    onInternalNumberChange: (e: any) => void;
    onInsuranceCompanyChange: (e: any) => void;
    onSueNewCommentChange: (e: any, field: string) => void;
    onSueAddComment: () => void;
    onPolicyNumberChange: (e: any) => void;
    // add this functiopn const onHandlingTypeChange = async (value: string, option: { label: string; value: string; } | { label: string; value: string; }[]| undefined) => {
    onHandlingTypeChange: (value: string) => void;
    onHandlingTypeCareChange: (e: any) => void;
    onSueNewPaymentChange: (e: any, name: string, onlyNumbers?: boolean) => void;
    onSueNewPaymentDateChange: (date: any) => void;
    onSueAddPayment: () => void;

    setShowNewPayment: Function;
    sueCommentsList: any[];
    sueTypes: any[];
    newSueComment: any;
    config: any;
    suePaymentsList: any[];
}

const GeneralCarDetails = (props: GeneralCarDetailsProps) => {

    useEffect(() => {
        console.log('GeneralCarDetails-props.sueData', props.sueData)
        console.log('GeneralCarDetails-formErrors', props.formErrors)
    }, [props.formErrors]);
    return (
        <div className='white-block white-block-fixed-height'>
            <section className=''>
                <div className='section-sue-title'>
                    פרטי תביעה
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' תביעה
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueNumber} onChange={(e: any) => props.onParameterChange(e, 'sueNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>

                    <div className={`parameter-item ${props.formErrors.policyNumber ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                מס' פוליסה
                            </div>
                            <div className="value">
                                <input type="text" readOnly={true} value={props.sueData.policy ? props.sueData.policy.policyNumber : props.sueData.rider && props.sueData.rider.subscriberNumber} onChange={(e: any) => props.onPolicyNumberChange(e)} onBlur={(e: any) => { }} />
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.status ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                <span style={{ color: 'red' }}>*</span>סטטוס
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="sue_statuses_list"
                                    placeholder='בחר סטטוס'
                                    onChange={props.onSueStatusChange}
                                    value={props.sueStatusLabel}
                                />
                                <datalist id="sue_statuses_list">
                                    {props.config.sueStatuses && props.config.sueStatuses.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueStatusLabel == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueStatus() }}></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' פנימי
                            </div>
                            <div className="value">
                                <input type="text" readOnly={true} value={props.sueInternalNumber} onChange={props.onInternalNumberChange} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.openingDate ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                <span style={{ color: 'red' }}>*</span>תאריך פתיחה
                            </div>
                            <div className="value">
                                <CompDatePicker value={props.openingDate} onChange={(e: any) => props.onChangeOpeningDate(e)} />
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך סגירה
                            </div>
                            <div className="value">
                                <CompDatePicker value={props.closingDate} onChange={(e: any) => props.onChangeClosingDate(e)} />
                            </div>
                        </div>
                    </div>

                </div>
                <div className="parameter-row">
                    <div className={`parameter-item ${props.formErrors.sueType ? 'has-errors' : ''}`}>
                        <div className={`field`}>
                            <div className="title">
                                <span style={{ color: 'red' }}>*</span>סוג תביעה
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="sue_types_list2"
                                    placeholder='בחר סוג תביעה'
                                    onChange={props.onSueTypeChange}
                                    value={props.sueTypeLabel}
                                />
                                <datalist id="sue_types_list2">
                                    {props.sueTypes && props.sueTypes.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueTypeLabel == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueType() }} ></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.activityStatus ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                <span style={{ color: 'red' }}>*</span>מצב תביעה
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="statuses_list"
                                    placeholder='בחר מצב'
                                    onChange={props.onSueActivityStatusChange}
                                    value={props.sueActivityStatusLabel}
                                />
                                <datalist id="statuses_list">
                                    {props.config.sueActivityStatuses && props.config.sueActivityStatuses.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueActivityStatusLabel == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueActivityStatus() }}></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>

                    <div className={`parameter-item ${props.formErrors.sueHandler ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                <span style={{ color: 'red' }}>*</span>מטפל בתביעה
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="sue_handlers_list2"
                                    placeholder='בחר מטפל בתביעה'
                                    onChange={props.onSueHandlerChange}
                                    value={props.sueHandlerName}
                                />
                                <datalist id="sue_handlers_list2">
                                    {props.config.handlers && props.config.handlers.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueHandlerName == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueHandler() }}></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מסלול טיפול בתביעה
                            </div>
                            <div className="value">
                                {/* <Select
                                    style={{ width: '100%' }}
                                    placeholder="רישיון  ישראלי"
                                    value={props.sueData.handlingType != null && props.sueData.handlingType >= 0 && props.sueData.handlingType.toString()}
                                    onChange={props.onHandlingTypeChange}
                                    options={
                                        [
                                            {
                                                label: 'מוסך הסדר',
                                                value: '0'
                                            },
                                            {
                                                label: 'ללא הסדר',
                                                value: '1'
                                            },
                                            {
                                                label: 'הסדר צד ג\'',
                                                value: '2'
                                            }
                                        ]
                                    }
                                /> */}

                                <input type='text'
                                    list="sue_handlers_list3"
                                    placeholder='בחר מסלול מטפל בתביעה'
                                    onChange={props.onHandlingTypeCareChange}
                                    value={props.sueHandlingProcess}
                                />
                                <datalist id="sue_handlers_list3">
                                    {[{label: 'מוסך הסדר',value: '0'},{label: 'ללא הסדר',value: '1'},{label: 'הסדר צד ג\'', value: '2'}]
                                    .map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.insuranceCompany ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                חברת ביטוח
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="companies_list"
                                    readOnly={true}
                                    placeholder='בחר חברת ביטוח'
                                    onChange={(e: any) => props.onInsuranceCompanyChange(e)}
                                    value={props.insuranceCompanyLabel}
                                />
                                <datalist id="companies_list">
                                    {props.config.insuranceCompanies.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                {/* {!props.sueData.rider && <div className={`icon x-clear pointer ${props.insuranceCompanyLabel == '' ? 'hide' : ''}`} onClick={onClearInsuranceCompany}></div>} */}
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                    </div>
                </div>

                <div className={`parameter-row single-item ${props.sueData.rider ? '' : 'hide'}`}>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                סוג כיסוי
                            </div>
                            <div className="value">
                                {props.sueData.rider && props.sueData.rider.riderPackages && props.sueData.rider.riderPackages.map((rPackage: any, key: number) => {
                                    return (<span key={key}>
                                        {
                                            rPackage.riderPackage.riderPackageServices.map((rps: any) => {
                                                return (<>
                                                    {rps.riderServiceCompany.riderService.title}
                                                    <br />
                                                </>)
                                            })
                                        }
                                    </span>)
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={`with-top-border ${props.sueData.rider ? 'hide' : ''}`}>
                <div className='section-sue-title'>
                    סגירת תביעה
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                נזק עפ"י שמאי
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.damageAppraiser} onChange={(e: any) => props.onSueSummaryAmountChange(e, 'damageAppraiser', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שכ"ט שמאי
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.appraiserAmount} onChange={(e: any) => props.onSueSummaryAmountChange(e, 'appraiserAmount', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>


                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                סכום ירידת ערך
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.impairment} onChange={(e: any) => props.onSueSummaryAmountChange(e, 'impairment', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                ירידת ערך ב%
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.impairmentPercent} onChange={(e: any) => props.onParameterChange(e, 'impairmentPercent', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                השתתפות עצמית
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.deductible} onChange={(e: any) => props.onSueSummaryAmountChange(e, 'deductible', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>

                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                ערך כינון
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.establishmentValue} onChange={(e: any) => props.onSueSummaryAmountChange(e, 'establishmentValue', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                הוצאות נוספות
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.additionalExpenses} onChange={(e: any) => props.onParameterChange(e, 'additionalExpenses', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                    </div>
                    <div className="parameter-item">
                    </div>
                    <div className="parameter-item">
                    </div>
                </div>
            </section>
            <section className='with-top-border'>
                <div className='section-sue-title'>
                    פרטי תשלום
                </div>
                <section className={` ${!props.sueData.rider ? 'hide' : ''}`}>
                    <div className='section-title'>
                        תשלומים
                    </div>

                    <div className={`${!props.showNewPayment ? 'hide' : 'parameter-row'}`}>
                        <div className={`parameter-item`}>
                            <div className="field">
                                <div className="title">
                                    סכום שנתבע
                                </div>
                                <div className="value">
                                    <input type="text" value={props.newSuePayment.requestedAmount} onChange={(e: any) => props.onSueNewPaymentChange(e, 'requestedAmount', true)} onBlur={(e: any) => { }} />
                                </div>
                            </div>
                        </div>
                        <div className={`parameter-item`}>
                            <div className="field">
                                <div className="title">
                                    סכום שאושר
                                </div>
                                <div className="value">
                                    <input type="text" value={props.newSuePayment.approvedAmount} onChange={(e: any) => props.onSueNewPaymentChange(e, 'approvedAmount', true)} onBlur={(e: any) => { }} />
                                </div>
                            </div>
                        </div>

                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    תאריך
                                </div>
                                <div className="value">
                                    <CompDatePicker value={props.newSuePayment.bankTransferDate} onChange={(date: any) => props.onSueNewPaymentDateChange(date)} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    ספק
                                </div>
                                <div className="value">
                                    <input type="text" value={props.newSuePayment.supplier ? props.newSuePayment.supplier : ''} onChange={(e: any) => props.onSueNewPaymentChange(e, 'supplier')} onBlur={(e: any) => { }} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    הערות
                                </div>
                                <div className="value">
                                    <input type="text" value={props.newSuePayment.title ? props.newSuePayment.title : ''} onChange={(e: any) => props.onSueNewPaymentChange(e, 'title')} onBlur={(e: any) => { }} />
                                </div>
                            </div>
                        </div>
                        <div className="parameter-item">
                            <div className="field">
                                <div className="title">
                                    &nbsp;
                                </div>
                                <div className="value no-border">
                                    <button className="button blue flex-centered flex-justify-center" onClick={props.onSueAddPayment}>הוסף תשלום</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {props.suePaymentsList && props.suePaymentsList.map((payment: any, index: number) => {
                        return (
                            <div className="parameter-row" key={index}>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className={`title ${index > 0 ? 'hide' : ''}`}>
                                            סכום שנתבע
                                        </div>
                                        <div className="value">
                                            {payment.requestedAmount}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className={`title ${index > 0 ? 'hide' : ''}`}>
                                            סכום שאושר
                                        </div>
                                        <div className="value">
                                            {payment.approvedAmount}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className={`title ${index > 0 ? 'hide' : ''}`}>
                                            תאריך
                                        </div>
                                        <div className="value">
                                            {payment.createdDate && moment(payment.bankTransferDate).format('DD-MM-YYYY')}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className={`title ${index > 0 ? 'hide' : ''}`}>
                                            ספק
                                        </div>
                                        <div className="value">
                                            {payment.supplier}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className={`title ${index > 0 ? 'hide' : ''}`}>
                                            הערות
                                        </div>
                                        <div className="value">
                                            {payment.title}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">

                                </div>
                            </div>
                        )
                    })}
                    <div className={`${props.showNewPayment ? 'hide' : 'parameter-row'}`}>
                        <div className='parameter-item'>
                            <button className="button blue flex-centered flex-justify-center" onClick={() => props.setShowNewPayment(true)}>הוסף תשלום חדש</button>
                        </div>
                    </div>
                </section>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                סכום שנתבע {
                                    props.sueData.rider && <>(סה"כ)</>
                                }
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.sueData.rider ? true : false} value={props.sueData.requestedAmount} onChange={(e: any) => props.onParameterChange(e, 'requestedAmount', true)} onBlur={(e: any) => { }} />
                            </div>

                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.approvedAmountPayment ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                סכום שאושר {
                                    props.sueData.rider && <>(סה"כ)</>
                                }
                            </div>
                            <div className="value">
                                <input type="text" readOnly={props.sueData.rider ? true : false} value={props.sueData.approvedAmount} onChange={(e: any) => props.onParameterChange(e, 'approvedAmount', true)} onBlur={(e: any) => { }} />
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך תשלום אחרון
                            </div>
                            <div className="value">
                                <CompDatePicker value={props.paymentDate} onChange={(e: any) => props.onChangePaymentDate(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך פירעון שק לקוח
                            </div>
                            <div className="value">
                                <CompDatePicker value={props.customerCheckMaturityDate} onChange={(e: any) => props.onChangeCustomerCheckMaturityDate(e)} />
                            </div>
                        </div>
                    </div>
                </div>

            </section >
            <section className='with-top-border flex-space-between'>
                <div style={{ flexGrow: '1' }}>
                    <div className='section-sue-title'>
                        הערות
                    </div>
                    <div>
                        <div>
                            הערה
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
                            <div>
                                <input
                                    style={{ height: '24px', padding: '5px 10px', border: '1px solid #d3dee6', width: '600px' }}
                                    type="text" value={props.newSueComment.comment ? props.newSueComment.comment : ''} onChange={(e: any) => props.onSueNewCommentChange(e, 'comment')} onBlur={(e: any) => { }} />
                            </div>
                            <div>
                                <button
                                    className='btn-save-comment'
                                    onClick={props.onSueAddComment}
                                    disabled={props.newSueComment.comment == null || props.newSueComment.comment.length == 0}
                                // style={props.newSueComment.comment && props.newSueComment.comment.length > 0 ? {backgroundColor: '#027bfcf0'} : { } }
                                >הוסף הערה</button>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: '40px' }}>
                        <div className='comment-header' >
                            <div className="item-comment" style={{ color: 'gray' }}>
                                הערה
                            </div>
                            <div className="item-owner" style={{ color: 'gray' }}>
                                תאריך
                            </div>
                            <div className="item-owner" style={{ color: 'gray' }}>
                                משתמש
                            </div>
                        </div>
                        <div className="content-table-body files-table">
                            {props.sueCommentsList && props.sueCommentsList.map((comment: any, index: number) => {
                                const user = props.config.users.find((u: any) => u.id === comment.userId);
                                const userName = user ? user.fullName : '';
                                return (
                                    <div className="comment-body-line" key={index}>
                                        <div className="item-comment">
                                            {comment.comment}
                                        </div>
                                        <div className="item-owner">
                                            {comment.createdDate && moment(comment.createdDate).format('DD-MM-YYYY')}
                                        </div>
                                        <div className="item-owner">
                                            {userName}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}

export default GeneralCarDetails